import { render, staticRenderFns } from "./Categorise.vue?vue&type=template&id=00429fba"
import script from "./Categorise.vue?vue&type=script&lang=js"
export * from "./Categorise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports